const local = {
    API: 'http://local.bpmsupreme.com:3002',
    API_DOWNLOAD: 'http://local.bpmsupreme.com:3003',
    API_DIRECT: undefined,
    NEW_POOL_URL: 'https://app.bpmsupreme.com',
    STORAGE_V: '2',
    POOL_URL: 'https://develop.bpmsupreme.com'
};
const dev = {
    API: 'https://api.develop.bpmsupreme.com',
    API_DOWNLOAD: 'https://api.develop.download.bpmsupreme.com/v1',
    API_DIRECT: undefined,
    NEW_POOL_URL: 'https://develop.bpmsupreme.com',
    STORAGE_V: '2',
    POOL_URL: 'https://develop.bpmsupreme.com'
};
const prod = {
    API: 'https://api.bpmsupreme.com',
    API_DOWNLOAD: 'https://api.download.bpmsupreme.com/v1',
    API_DIRECT: 'https://api-direct.bpmsupreme.com',
    NEW_POOL_URL: 'https://app.bpmsupreme.com',
    STORAGE_V: '2',
    POOL_URL: 'https://bpmsupreme.com'
};

const config = process.env.REACT_APP_ENV === 'local' ? prod :
    process.env.REACT_APP_ENV === 'production'
        ? prod
        : prod;
export let Environment = config


// WEBPACK FOOTER //
// ./src/env.ts